import privilege from "./privilege";
import review from "./review";
import reward from "./reward";
import board from "./board";
export default {
  privilege,
  review,
  reward,
  board,
};
